<template>
  <div class="wap_index2 main" id="yqJs">
    <div class="box_center box_centerflex">
      <div>
        <div class="wap_index2-title">
          <div>原创游戏展示</div>
        </div>
        <div class="wap_index2-video" v-if="engineMediaList.length">
          <video
            v-if="videoFlag"
            v-show="!popShow"
            id="index_2-video"
            webkit-playsinline="true"
            playsinline="true"
            controls
            ref="wapVideo"
            :src="engineMediaList[videoIndex].media"
            :poster="engineMediaList[videoIndex].phone_img"
          ></video>
          <div class="play" @click="wapPlay" v-if="wapShow"></div>
        </div>
        <div class="videoList">
          <div
            class="videoList-li"
            @click="videoChoice(index)"
            v-for="(item, index) in engineMediaList.slice(0,4)"
            :key="index"
          >
            <video :src="item.media" :poster="item.phone_img"></video>
          </div>
        </div>
        <div class="wap_index2-title1">
          <div>盒子引擎介绍</div>
        </div>
      </div>
      <div class="wap_index2_flex1">
        <div class="swiper wap_index2_slide" v-if="showHeight">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in slideList1"
              :key="index"
            >
              <div>
                <div
                  class="wap_index2_slide-ul_li"
                  v-for="(val, valIndex) in item.title"
                  :key="valIndex"
                >
                  <div>
                    <div class="wap_index2_slide-ul_li_title">
                      <div :class="`slideList${index}${valIndex}`"></div>
                      <div>{{ val }}</div>
                    </div>
                    <div>{{ item.content[valIndex] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!--分页器。如果放置在swiper外面，需要自定义样式。-->
        </div>
        <div class="swiper wap_index2_slide" v-else>
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in slideGatherCopy"
              :key="index"
            >
              <div>
                <div class="wap_index2_slide-ul_li">
                  <div>
                    <div class="wap_index2_slide-ul_li_title">
                      <div :class="`slideList4${index}`"></div>
                      <div>{{ item.title }}</div>
                    </div>
                    <div>{{ item.content }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!--分页器。如果放置在swiper外面，需要自定义样式。-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      showHeight: true,
      videoFlag: true,
      wapShow: true,
      videoIndex: 0, //当前播放的视频
      popShow: false,
      slideList1: [
        {
          title: ["正版授权 三端互通", "可视化开发 自由定制"],
          content: [
            "亚拓士中国大陆地区独家千年IP代理资质，原生引擎支持,IOS、Android、pc、H5、3D多平台，高效，稳定，完美实现多端互通",
            "独家原生开发引擎，共享资源库，自由编辑游戏GUI界面，各项游戏参数，自由配置定义游戏玩法，任务，活动，地图，怪物，人物等游戏内容，轻松打造专属千年版本",
          ],
        },
        {
          title: [
            "接入网易易盾反外挂，破解加固系统",
            "完美兼容其他千年引擎，一键转换",
          ],
          content: [
            "智能外挂排查,拦截，在网络层，应用层，系统层提供全面防护，让游戏运行之路一帆风顺",
            "原生引擎兼容市面绝大部分千年引擎，一键实现数据，资源转化，助力千年开发者，运营者快速开发",
          ],
        },
        {
          title: ["引擎自带多套完成度100%千年游戏底板", "千年盒子流量支持"],
          content: [
            "助力开发者快速实现版本商业化",
            '合作伙伴可免费入驻千年游戏盒子，首发第一周可获得推荐资源位扶持"',
          ],
        },
        {
          title: ["完善的运营和运维工具", "7*24小时对接团队保驾护航"],
          content: [
            "我们为开发者提供完善的GM后台，数据综合后台，万能后台，BI后台，让开发者实时掌控产品信息，用户信息，区服生态信息。",
            "专业的 技术，运营，客服，市场团队全程对接支持，让您成功之路事半功倍",
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.yqSwiper();
  },
  computed: {
    ...mapState({
      engineMediaList: (state) => state.init.engineMediaList,
    })
  },
  methods: {
    // 引擎介绍轮播图
    yqSwiper() {
      this.mySwiperbox2 = new Swiper(".wap_index2_slide", {
        autoplay: true, //可选选项，自动滑动
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          clickableClass: "my-pagination-clickable",
        },
        loop: true,
        centeredSlides: true,
      });
    },
    // 选择视频播放
    videoChoice(index) {
      this.wapShow = true;
      this.videoIndex = index;
      this.resetVideo();
      // this.$refs.wapVideo.load()
    },
    // 视频播放在手机浏览器不兼容
    resetVideo() {
      this.videoFlag = false;
      setTimeout(() => {
        this.videoFlag = true;
        this.videoShow = false;
      }, 0);
    },
    //移动端原创游戏展示 视频播放完重置
    wapVideoReset() {
      try {
        // play 视频开始播放
        this.$refs.wapVideo.addEventListener("play", () => {
          this.videoShow = true;
        });
        // ended 视频播放结束
        this.$refs.wapVideo.addEventListener("ended", () => {
          this.wapShow = true;
          this.resetVideo();
          // this.$refs.wapVideo.load()
        });
      } catch (error) {}
    },
    //点击播放视频
    wapPlay() {
      this.wapShow = false;
      this.$refs.wapVideo.play();
    },
  },
};
</script>

<style scoped lang="scss">
.box_centerflex {
  display: flex;
  flex-direction: column;
}
.wap_index2_flex1 {
  flex: 1 !important;
}
.wap_index2 {
  background: url("../../assets/images/web/two_bg.png") no-repeat center;
  background-size: cover;
}

.wap_index2-title {
  padding-top: 1.466667rem /* 55/37.5 */;
  padding-bottom: 0.533333rem /* 20/37.5 */;
  text-align: center;
}

.wap_index2-title div:nth-child(1) {
  font-size: 0.533333rem /* 20/37.5 */;
  font-weight: bold;
  color: #fff;
}

.wap_index2-title div:nth-child(2) {
  font-size: 0.32rem /* 12/37.5 */;
  color: #a2a2a2;
}

.wap_index2-video {
  width: 100%;
  height: 4.266667rem /* 160/37.5 */;
  border-radius: 0.266667rem /* 10/37.5 */;
  margin-bottom: 0.213333rem /* 8/37.5 */;
  background: #000;
  position: relative;
  opacity: 0.8;
  z-index: 0;
}

.wap_index2-video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.266667rem /* 10/37.5 */;
  z-index: 1;
}

.wap_index2-video::after {
  /* content: ""; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.266667rem /* 10/37.5 */;
  opacity: 0.27;
  background: #000;
}
.wap_index2-video .play {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 1.28rem /* 48/37.5 */;
  height: 1.306667rem /* 49/37.5 */;
  background: url("../../assets/images/web/play.png") no-repeat center;
  background-size: cover;
  z-index: 9999999;
}
.videoList {
  display: flex;
  // justify-content: space-between;
}

.videoList .videoList-li {
  width: 2.933333rem /* 110/37.5 */;
  height: 1.68rem /* 63/37.5 */;
  border-radius: 0.133333rem /* 5/37.5 */;
  position: relative;
  flex: 0.32;
  overflow: hidden;
}
.videoList .videoList-li+.videoList-li{
  margin-left: .266667rem /* 10/37.5 */;
}
.videoList .videoList-li video {
  width: 100%;
  height: 100%;
  border-radius: 0.266667rem /* 10/37.5 */;
  object-fit: cover;
}

.videoList .videoList-li::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 2.933333rem /* 110/37.5 */;
  width: 100%;
  height: 1.68rem /* 63/37.5 */;
  opacity: 0.5;
  background: #6b150b;
  border-radius: 0.133333rem /* 5/37.5 */;
  z-index: 1;
}

.wap_index2-title1 {
  padding-top: 0.4rem /* 15/37.5 */;
  padding-bottom: 0.213333rem /* 8/37.5 */;
  margin-bottom: 0.266667rem /* 10/37.5 */;
  text-align: center;
  border-bottom: 0.053333rem /* 2/37.5 */ solid #707070;
}

.wap_index2-title1 div:nth-child(1) {
  font-size: 0.533333rem /* 20/37.5 */;
  font-weight: bold;
  color: #fff;
}

.wap_index2-title1 div:nth-child(2) {
  font-size: 0.32rem /* 12/37.5 */;
  color: #a2a2a2;
}

.wap_index2_slide {
  width: 100%;
  height: 100%;
  /* overflow-x: scroll; */
  position: relative;
  height: 100%;
  /* transform: scaleY(-1); */
  /* display: flex;
    flex-direction: column; */
  --swiper-theme-color: #fff;
  --swiper-pagination-color: #fff; /* 两种都可以 */
}

.slideList20 {
  background: url("../../assets/images/web/box_info-yq.png");
}
.slideList21 {
  background: url("../../assets/images/web/box_info-7.png");
}
.slideList30 {
  background: url("../../assets/images/web/box_info-3.png");
}
.slideList31 {
  background: url("../../assets/images/web/box_info-8.png");
}

.slideList00 {
  background: url("../../assets/images/web/box_info-1.png");
}
.slideList01 {
  background: url("../../assets/images/web/box_info-2.png");
}
.slideList10 {
  background: url("../../assets/images/web/box_info-4.png");
}
.slideList11 {
  background: url("../../assets/images/web/box_info-5.png");
}

.slideList40 {
  background: url("../../assets/images/web/box_info-1.png");
}
.slideList41 {
  background: url("../../assets/images/web/box_info-2.png");
}
.slideList42 {
  background: url("../../assets/images/web/box_info-4.png");
}
.slideList43 {
  background: url("../../assets/images/web/box_info-5.png");
}
.slideList44 {
  background: url("../../assets/images/web/box_info-yq.png");
}
.slideList45 {
  background: url("../../assets/images/web/box_info-7.png");
}
.slideList46 {
  background: url("../../assets/images/web/box_info-3.png");
}
.slideList47 {
  background: url("../../assets/images/web/box_info-8.png");
}

.wap_index2_unlike {
  height: 100%;
  display: flex;
  align-items: center;
}
.wap_index2_slide::-webkit-scrollbar {
  height: 0.053333rem /* 2/37.5 */ !important;
  background-color: #707070 !important;
}

.wap_index2_slide::-webkit-scrollbar-thumb {
  background-color: #f7f7f7 !important;
}

.wap_index2_slide-ul {
  display: flex;
  transform: scaleY(-1);
  flex: 0.5;
  position: relative;
}

.wap_index2_slide_showHeight {
  flex-direction: row !important;
}
.showHeight {
  display: flex;
}
.wap_index2_slide-ul_li {
  flex-shrink: 0;
  /* width: 5.946667rem ;
    margin-right:.826667rem ; */
  width: 100%;
}

.wap_index2_slide-ul_li_title {
  margin-bottom: 0.213333rem /* 8/37.5 */;
  display: flex;
}

.wap_index2_slide-ul_li_title > div:nth-child(1) {
  width: 0.96rem /* 36/37.5 */;
  height: 0.96rem /* 36/37.5 */;
  background-size: cover;
}

.wap_index2_slide-ul_li_title > div:nth-child(2) {
  display: flex;
  align-items: center;
  padding-left: 0.293333rem /* 11/37.5 */;
  font-size: 0.373333rem /* 14/37.5 */;
  color: #fff;
  font-weight: bold;
  flex: 1;
}

.wap_index2_slide-ul_li > div > div:nth-child(2) {
  font-size: 0.32rem /* 12/37.5 */;
  color: #b1b1b1;
  line-height: 0.426667rem /* 16/37.5 */;
  height: 1.866667rem /* 70/37.5 */;
}
.wap_index2_slide {
  width: 100%;
  height: 100%;
}
.wap_index2_slide .swiper-slide {
  width: 100%;
  height: 100%;
}
@media (max-width: 750px) and (max-height: 667px) {
  .wap_index2-video {
    width: 100%;
    height: 4rem /* 150/37.5 */;
    border-radius: 0.266667rem /* 10/37.5 */;
    margin-bottom: 0.213333rem /* 8/37.5 */;
    background: #000;
    position: relative;
  }
  .wap_index2-title1 {
    padding: 0.533333rem /* 20/37.5 */ 0;
  }
  .wap_index2_unlike {
    align-items: inherit;
  }
  .wap_index2_unlike > div {
    margin-top: 0.586667rem /* 22/37.5 */;
  }
  .wap_index2-title {
    padding-top: 1.466667rem /* 55/37.5 */;
    padding-bottom: 0.4rem /* 15/37.5 */;
  }
}
</style>
